<template>
  <h2>HealthCheck</h2>
</template>

<script setup>

</script>

<style scoped>

</style>